// extracted by mini-css-extract-plugin
export default {"badgeUsed":"BadgeUsed_badgeUsed__lYK54","galaxy":"BadgeUsed_galaxy__t5xAb","buttonContainer":"BadgeUsed_buttonContainer__noJv7"};